tsandcs.$inject = ["API_URL", "$sce"];
angular.module('calendarApp').directive('tsandcs', tsandcs);

var stripScripts = function stripScripts(a, b, c) {
  b = new Option();
  b.innerHTML = a;

  for (a = b.getElementsByTagName('script'); c = a[0];) {
    c.parentNode.removeChild(c);
  }

  return b.innerHTML;
};

function tsandcs(API_URL, $sce) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/settings/tsandcs.html',
    scope: {
      tsandcsText: '@',
      termsAgreed: '='
    },
    link: function link(scope, elem, attrs) {
      scope.tsandcsHtml = $sce.trustAsHtml(stripScripts(scope.tsandcsText));
    }
  };
}